import { Link } from "react-router-dom";
import { Button } from "../../component/ui/button";
import { supportLinks } from "../../../env-exports";

type HelpSectionProps = {
  isStudent?: boolean;
};

export default function HelpSection({ isStudent }: HelpSectionProps) {
  const supportLink = isStudent ? supportLinks.student : supportLinks.staff;

  return (
    <div className="flex flex-col items-center justify-center gap-4 bg-curtin-secondary-gray-07 px-4 py-16 text-center">
      <h3 className="text-[28px] font-bold leading-9 text-[var(--color-curtin-secondary-black-100)] [font-family:var(--font-effra)]">Get in touch</h3>
      <p className="text-lg font-normal leading-7 text-[var(--color-curtin-secondary-gray-01)] [font-family:var(--font-proxima-nova)]">
        Have a question or feedback?{" "}
        <br className="sm:hidden" />
        We&apos;d love to hear from you.
      </p>
      <Button
        asChild
        variant="ghost"
        className="flex h-[40px] gap-[10px] rounded-[5px] border-2 border-curtin-purple bg-white px-[30px] py-[15px] text-base text-curtin-purple hover:bg-curtin-purple hover:text-white focus-visible:bg-curtin-purple focus-visible:text-white focus-visible:ring-2"
      >
        <Link
          to={supportLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Support
        </Link>
      </Button>
    </div>
  );
}
